import { WifiOff } from 'lucide-react';
import { useConnectivity } from '../hooks/useConnectivity';
import { isNativePlatform } from '../lib/runtime';
import { cn } from '../lib/utils';

/** Branded offline strip. Online ≠ API reachable — this only tracks the device link. */
export function OfflineBanner() {
  const { connected, ready } = useConnectivity();

  if (!ready || connected) return null;

  return (
    <div
      role="status"
      className={cn(
        'fixed inset-x-0 z-[55] border-t border-amber-500/30 bg-[#1a0f12]/px-4 py-2.5 text-center text-sm text-amber-100',
        isNativePlatform()
          ? 'bottom-[calc(3.35rem+env(safe-area-inset-bottom,0px))]'
          : 'bottom-0'
      )}
    >
      <span className="inline-flex items-center justify-center gap-2">
        <WifiOff className="h-4 w-4 shrink-0" aria-hidden />
        You&apos;re offline. Saved lists stay available; new picks need a connection.
      </span>
    </div>
  );
}
